import * as Yup from 'yup';
import PropTypes from 'prop-types';

export const usePostedJobsFilter = ({ setFilters, dateType }) => {
  const formSchema = Yup.object().shape({
    date: Yup.string().nullable(),
  });

  const onSubmit = ({ date }) => {
    setFilters({ [dateType]: date || null });
  };

  return {
    formSchema,
    onSubmit,
  };
};

usePostedJobsFilter.propTypes = {
  setFilters: PropTypes.func.isRequired,
  dateType: PropTypes.string.isRequired,
};
